const BUSINESS_TYPE = {
  business: 'BUSINESS',
  headToHead: 'HEADTOHEAD',
  recommendation: 'RECOMMENDATION',
};

export default BUSINESS_TYPE;
